// extracted by mini-css-extract-plugin
export default {"summary":"TaskPermissionActionFolderPage_summary__SaO6S","title":"TaskPermissionActionFolderPage_title__C1ERr"};